"use client";

import { useLocale } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";

interface LoadingRowProps {
  i18nData?: I18nData;
}

export default function LoadingRow({ i18nData }: LoadingRowProps) {
  const { locale } = useLocale();
  
  return (
    <tr>
      <td colSpan={100} className="py-10 text-center">
        {i18nData?.[locale]?.loading ?? "Loading results..."}
      </td>
    </tr>
  );
}
